/**
 * Core Modules Index
 */

// Utilities
import debug from "debug";
const MODULE_NAME = 'app.core/modules';
const log = debug(MODULE_NAME);


import * as licencePing from './licence-ping';
import * as sticky from './sticky';
import * as toggleClass from './toggle-class';
import * as toggleDisable from './toggle-disable';
import * as navigation from './navigation';
import * as sliders from './sliders';
import * as breadcrumbs from './breadcrumbs';
import * as forms from './forms';
import * as customSelect from './custom-select';
import * as transportElements from './transport-elements';
import * as videoBlocks from './video-blocks';
import * as imageGallery from './image-gallery';
import * as acceptCookie from './accept-cookie';
import * as ajaxValidate from './ajax-validate';
import * as disableOnSubmit from './disable-on-submit';
import * as addToQuote from './quote';
import * as ajaxSaveOnChange from './ajax-save-on-change';
import * as ajaxSaveOnCheck from './ajax-save-on-check';
import * as countryModal from './country-modal';
import * as stickyNavigation from './sticky-navigation';
import * as toggleOnDirty from './toggle-on-dirty';
import * as toggleIfValue from './toggle-if-value';
import * as analyticsTrigger from './analytics-trigger';
import * as commerceAnalyticsTrigger from './commerce-analytics-trigger';
import * as syncValue from './sync-value';
import * as addressValidation from './address-validation';
import * as popWindow from './pop-window';
import * as locationChange from './location-change';
import * as colourPicker from './colour-picker';
import * as facebookFeedBlock from './facebook-feed-block';
import * as expressJobWidgetBlock from './express-job-widget-block';
import * as youtubeListBlock from './youtube-list-block';
import * as storeLocatorMap from './store-locator-map';
import * as storeLocatorSearch from './store-locator-search';
import * as storeLocation from './store-location';
import * as searchDropdown from './search-dropdown';
import * as dismiss from './dismiss';
import * as registrationForm from './registration-form';
import * as productDetail from './product-detail';
import * as availableColourSwatches from './available-colour-swatches';
import * as countdownTimer from './countdown-timer';
import * as sortableProducts from './sortable-products';
import * as clickTracking from './click-tracking';
import * as lazyLoad from './lazy-load';
import * as unbxd from './unbxd-implementation';
import * as treeMenu from './tree-menu';
import * as hoverLabel from './hover-label';
import * as salesForceCookie from './sales-force-cookie';
import * as salesForcePush from './sales-force-push';
import * as videoBanner from './video-banner';
import * as collapsible from './collapsible';
import * as triggerEvent from './trigger-event';
import * as tabsController from './tabs';
import * as exclusiveCollapsible from './exclusive-collapsible';
import * as iframeResize from './iframe-resize/iframe-resize';
import * as galleryCarousel from "./gallery-carousel";
import * as swatchRow from "./swatch-row";
import * as fieldToggle from "./field-toggle";

// Export
function exec () {
	log('Running...');

	licencePing.exec();
	sticky.exec();
	navigation.exec();
	sliders.exec();
	breadcrumbs.exec();
	customSelect.exec();
	forms.exec();
	transportElements.exec();
	videoBlocks.exec();
	imageGallery.exec();
	acceptCookie.exec();
	ajaxValidate.exec();
	disableOnSubmit.exec();
	countryModal.exec();
	addToQuote.exec();
	stickyNavigation.exec();
	toggleOnDirty.exec();
	toggleIfValue.exec();
	ajaxSaveOnChange.exec();
	ajaxSaveOnCheck.exec();
	syncValue.exec();
	toggleDisable.exec();
	addressValidation.exec();
	popWindow.exec();
	locationChange.exec();
	colourPicker.exec();
	facebookFeedBlock.exec();
	expressJobWidgetBlock.exec();
	youtubeListBlock.exec();
	storeLocatorMap.exec();
	storeLocatorSearch.exec();
	storeLocation.exec();
	searchDropdown.exec();
	dismiss.exec();
	registrationForm.exec();
	productDetail.exec();
	availableColourSwatches.exec();
	countdownTimer.exec();
	sortableProducts.exec();
	clickTracking.exec();
	lazyLoad.exec();
	unbxd.exec();
    hoverLabel.exec();
    salesForceCookie.exec();
    salesForcePush.exec();
    videoBanner.exec();
    collapsible.exec();
    triggerEvent.exec();
    tabsController.exec();
    iframeResize.exec();
    galleryCarousel.exec();
    swatchRow.exec();
    fieldToggle.exec();
    exclusiveCollapsible.exec();

	//  keep this last - triggers events consumed by customSelect
	toggleClass.exec();
	analyticsTrigger.exec();
	commerceAnalyticsTrigger.exec();
}

function execAfter () {
	log('Running after...');
    treeMenu.exec();
}

export default {
	exec,
    execAfter
};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/index.js